export const PlayIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9333 8.6144C14.7209 9.06912 15.1147 9.29648 15.2469 9.5933C15.3621 9.85221 15.3621 10.1479 15.2469 10.4068C15.1147 10.7036 14.7209 10.931 13.9333 11.3857L8.73333 14.3879C7.94574 14.8426 7.55194 15.07 7.2288 15.036C6.94694 15.0064 6.69089 14.8586 6.52431 14.6293C6.33333 14.3664 6.33333 13.9117 6.33333 13.0023V6.99782C6.33333 6.08839 6.33333 5.63367 6.52431 5.3708C6.69089 5.14152 6.94694 4.99369 7.2288 4.96407C7.55194 4.9301 7.94574 5.15746 8.73333 5.61218L13.9333 8.6144Z"
      fill="currentColor"
    />
  </svg>
);

export const PauseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.33334"
      y="4.16663"
      width="3.33333"
      height="11.6667"
      rx="1"
      fill="currentColor"
    />
    <rect
      x="11.3333"
      y="4.16663"
      width="3.33333"
      height="11.6667"
      rx="1"
      fill="currentColor"
    />
  </svg>
);
